import { useEffect, useState } from "react";
import style from "./FunnelV2.module.css";
import ContentEditable from "react-contenteditable";
import sanitizeHTML from "sanitize-html";
import { ref, update } from "firebase/database";
import { db } from "../../../configs/Firebase";

const FunnelV2 = (props) => {
  const [hasRendered, setHasRendered] = useState(false);
  const [cellVal, setCellVal] = useState();

  useEffect(() => {
    if (!props.editable || !hasRendered) {
      setCellVal(props.data.value);
    }
    setHasRendered(true);
  }, [props.data.value]);

  function selectAll(e) {
    var range, selection;
    if (document.body.createTextRange) {
      range = document.body.createTextRange();
      range.moveToElementText(e.currentTarget);
      range.select();
    } else if (window.getSelection) {
      selection = window.getSelection();
      range = document.createRange();
      range.selectNodeContents(e.currentTarget);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }


  function getFunnel(start, end, span, index) {
    // console.log(start+" - "+end+" - "+props.row.columns[index+1]);
    return (
      <div
        className={style.funnelNew}
        style={{ "--converted": start, "--next": end }}
      >
        <div
          className={style.converted}
          style={{
            background:
              "linear-gradient(90deg, " +
              getColor(parseFloat(start) / 100) +
              " 0%, " +
              getColor(parseFloat(end) / 100) +
              " 100%)",
          }}
        ></div>
        <div className={`${style.dropoff} ${props.row.columns[index+1] === undefined && style.hide}`} style={{ "--dropoff": start - end }}>
          <div className={style.amount}>
            {Math.round(((start - end) / start) * 100)}%
          </div>
        </div>
      </div>
    );
  }


  

  function getValue(index, dir) {
    let i = index;
    if (dir === "next") {
      i = index + 1;
    }
    if (dir === "prev") {
      i = index - 1;
    }
    if (i < 0) {
      i = 0;
    }
    if (props.row.columns[i]) {
      return props.row.columns[i].value;
    }else{
      return props.row.columns[i-1];
    }
  }
  function getRelative(index) {
    let i = index - 1;
    if (i < 0) {
      i = 0;
    }
    return Math.round(
      (props.row.columns[index].value / props.row.columns[i].value) * 100
    );
  }
  // function getNext(index) {
  //   let i = index + 1;
  //   if (i < 0) {
  //     i = 0;
  //   }
  //   return Math.round(
  //     (props.row.columns[index].value / props.row.columns[i].value) * 100
  //   );
  // }

  function getColor(value) {
    var hue = (value * 120).toString(10);
    return ["hsl(", hue, ",65%,70%)"].join("");
  }

  function checkboxChangeHandler(e, columnId) {
    if (!e.target.checked) {
      update(ref(db), {
        [props.journeyRefURL +
        "/rows/" +
        props.row.id +
        "/columns/" +
        columnId +
        "/status"]: "off",
      });
    } else {
      update(ref(db), {
        [props.journeyRefURL +
        "/rows/" +
        props.row.id +
        "/columns/" +
        columnId +
        "/status"]: "on",
      });
    }
  }

  function isNumber(o) {
    return o === "" || !isNaN(o - 0);
  }
  function numbersOnly(e) {
    if (
      !isNumber(String.fromCharCode(e.keyCode)) &&
      e.keyCode !== 8 &&
      e.keyCode !== 37 &&
      e.keyCode !== 39 &&
      e.keyCode !== 190
    ) {
      e.preventDefault();
    }
  }
  function onChangeHandler(e, columnId) {
    let val = parseFloat(e.target.value);
    if (val > 100) {
      val = 100;
    }
    if (val < 0 || val === "" || isNaN(val)) {
      val = 0;
    }

    update(ref(db), {
      [props.journeyRefURL +
      "/rows/" +
      props.row.id +
      "/columns/" +
      columnId +
      "/value"]: sanitizeHTML(val),
    });
    setCellVal(val);
  }

  return (
    <div
      className={`${style.cell} ${props.data.status === "off" && style.none} ${
        props.first && style.first
      } ${props.last && style.last}`}
    >
      <div className={style.value}>
        {props.editable ? (
          <>
            <span>
              <input
                type="checkbox"
                checked={props.data.status === "off" ? false : true}
                onChange={(e) => checkboxChangeHandler(e, props.cellIndex)}
              />
            </span>
            {props.data.status === "off" ? (
              "N/A"
            ) : (
              <ContentEditable
                html={sanitizeHTML(cellVal)}
                type="number"
                onKeyDown={numbersOnly}
                onChange={(e) => onChangeHandler(e, props.cellIndex)}
                onFocus={(e) => selectAll(e)}
              />
            )}
          </>
        ) : props.data.status === "off" ? (
          "N/A"
        ) : (
          <div
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(
                cellVal + "% (" + getRelative(props.index) + "%)"
              ),
            }}
          />
          // <div>{props.index}</div>
        )}
      </div>
      {getFunnel(
        props.data.status === "off"
          ? getValue(props.index, "prev")
          : props.data.value,
        props.row.columns[props.index + 1]
          ? props.row.columns[props.index + 1].status === "off"
            ? getValue(props.index + 1, "next")
            : props.row.columns[props.index + 1].value
          : props.data.value,
        props.data.span ? props.data.span : 1,
        props.index
      )}
    </div>
  );
};

export default FunnelV2;
